import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import BrandStory from './components/BrandStory';
import SharedProcess from '../../components/sections/SharedProcess';
import SharedWhyUs from '../../components/sections/SharedWhyUs';
import SharedAreas from '../../components/sections/SharedAreas';
import SharedTestimonials from '../../components/sections/SharedTestimonials';
import SharedFAQ from '../../components/sections/SharedFAQ';
import QuoteFormCTA from '../../components/sections/QuoteFormCTA';

const aboutFaqs = [
  { q: 'Where is Hometown Painters located?', a: 'Hometown Painters is based at 1451 Landmeier Rd Unit G-B, Elk Grove Village, IL 60007. We serve the greater Chicago suburbs including Arlington Heights, Des Plaines, Bloomingdale, Schaumburg, Park Ridge, and surrounding communities.' },
  { q: 'What painting services does Hometown Painters offer?', a: 'We offer interior painting, exterior painting, cabinet painting, commercial painting, HOA painting, and new construction painting throughout Elk Grove Village and the Chicago suburbs.' },
  { q: 'Is Hometown Painters insured?', a: 'Yes. Hometown Painters operates with fully insured, professional crews. We maintain clean, organized job sites and use professional-grade materials to protect your home and deliver consistent, high-quality results.' },
  { q: 'How do I get a quote from Hometown Painters?', a: 'Simply call us at (847) 870-1600, email sales@hometownpainters.com, or fill out our online request form. We offer free consultations and will provide transparent pricing based on your project scope.' },
  { q: 'Does Hometown Painters handle large commercial or HOA projects?', a: 'Absolutely. We have direct experience completing large-scale multi-unit residential and commercial projects, including full condo building renovations completed efficiently with minimal disruption to residents or operations.' },
];

export default function AboutPage() {
  return (
    <div className="bg-charcoal-900 font-sans">
      <Header />
      <main>
        <AboutHero />
        <BrandStory />
        <SharedProcess />
        <SharedWhyUs />
        <SharedAreas />
        <SharedTestimonials />
        <SharedFAQ faqs={aboutFaqs} heading="About Hometown Painters" />
        <QuoteFormCTA heading="Ready to Start Your Project?" formId="about-quote-form" />
      </main>
      <Footer />
      <div className="md:hidden h-16" />
    </div>
  );
}
